import { render, staticRenderFns } from "./EditDocumento.vue?vue&type=template&id=d001be22"
import script from "./EditDocumento.vue?vue&type=script&setup=true&lang=js"
export * from "./EditDocumento.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports